import { auth, isAdmin, isUser } from "@/router/auth";
import { RouteConfig } from "vue-router";
import * as SubModules from '../sub_module'
const routes: Array<RouteConfig> = [ {
                path: '/shops/:instance',
                beforeEnter : async (to, from, next) => {
                    await auth();
                    if (isUser() || isAdmin()){
                      next();
                    } else {
                      next('/login?next='+to.fullPath);
                    }
                },
                name: 'shop-dashboard',
                component: () => import(/* webpackChunkName: "shop-dashboard" */ '../views/Dashboard.vue'),
                children: [
                  ...Object.values(SubModules).flat(),
                ]
        },
]

export default routes;